import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DiscountGroupService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 3117
     * @datataskName sp_ws_p2_discgrpprod_list
     * @param params
     * @returns promise containing list of discount groups for products.
     */
    public getDiscountGroupProducts(params?: GetDiscountGroupProductsParams): Promise<DiscountGroupProductItem[]> {
        return this.datatask.Post(3117, params);
    }

    /**
     * @datatask 3113
     * @datataskName sp_ws_p2_discgrpprod_get
     * @param params
     * @returns promise containing the dicount group product object.
     */
    public async getDiscountGroupProduct(params: GetDiscountGroupProductParams): Promise<DiscountGroupProductGet> {
        return (await this.datatask.Post(3113, params))[0];
    }

    /**
     * @datatask 3813
     * @datataskName tt_special_discount2_list
     * @returns promise containing list of special discount 2 items.
     */
    public async getSpecialDiscount2s(): Promise<SpecialDiscount2Item[]> {
        return this.datatask.Post(3813);
    }
}

export interface GetDiscountGroupProductParams {
    discgrpprod_keyno: string;
}

export interface DiscountGroupProductGet {
    discgrpprod_keyno: string;
    discgrpprod_name: string;
    pricemethod_id: string;
    calc_factor: string | number;
    calc_margin_pst: string | number;
}

export interface GetDiscountGroupProductsParams {
    /**
     * @default '0'
     */
    add_from_prodgrp?: '1' | '0';
}

export interface DiscountGroupProductItem {
    discgrpprod_keyno: string;
    discgrpprod_name: string;
    orderby: string;
}

export interface SpecialDiscount2Item {
    special_discount2_keyno: string;
    discount_name: string;
}
